import script from "./MicrochipInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./MicrochipInput.vue?vue&type=script&setup=true&lang=ts"

import "./MicrochipInput.vue?vue&type=style&index=0&id=00c4229e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src839921157/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00c4229e"]])

export default __exports__